import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { IssuerResponse } from '@/repositories/generated';

const response: IssuerResponse[] = [
  {
    id: '1',
    name: 'モックイシュア1',
  },
  {
    id: '2',
    name: 'モックイシュア2',
  },
  {
    id: '3',
    name: 'モックイシュア3',
  },
  {
    id: '32',
    name: 'モックイシュア３',
  },
  {
    id: '52',
    name: 'モックイシュア５',
  },
];

export const autocompleteIssuer = http.get(
  createMockEndpoint('/autocomplete/issuer'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
